module.exports = __webpack_public_path__ + "img/female-q.beabb474.jpg";